<template lang="">
  <div class="faq-section faq-two dark-bg section-padding">
    <div class="container">
      <div class="row">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-12 wow fadeInDown animated"
          data-wow-delay="200ms"
        >
          <div class="section-title">
            <p>General Questions</p>
            <h2 class="text-white">Frequently Asked Question.</h2>
          </div>
          <Accordion :type="true" />
        </div>
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-12 wow fadeInUp animated"
          data-wow-delay="200ms"
        >
          <div class="contact-form-wrap">
            <div class="contact-form-header">
              <p>SEND A MESSAGE</p>
              <h2>Request A Call Back</h2>
            </div>

            <div class="contact-form-inner">
              <form @submit.prevent="handleSubmit" id="faqContactForm">
                <div v-if="formMessage" :class="['alert', formMessage.type === 'success' ? 'alert-success' : 'alert-danger']">
                  {{ formMessage.text }}
                </div>
                <div class="row">
                  <div class="col-lg-6 col-12">
                    <input 
                      type="text" 
                      placeholder="Name" 
                      v-model="formData.name"
                      required
                      maxlength="100"
                    />
                  </div>
                  <div class="col-lg-6 col-12">
                    <input 
                      type="text" 
                      placeholder="Phone" 
                      v-model="formData.contact"
                      required
                      maxlength="100"
                    />
                  </div>
                  <div class="col-lg-6 col-12">
                    <input 
                      type="email" 
                      placeholder="Email" 
                      v-model="formData.email"
                      required
                      maxlength="100"
                    />
                  </div>
                  <div class="col-lg-6 col-12">
                    <input 
                      type="text" 
                      placeholder="How can help you?" 
                      v-model="formData.subject"
                      maxlength="100"
                    />
                  </div>
                  <div class="col-12">
                    <textarea
                      name="message"
                      id="message"
                      cols="30"
                      rows="10"
                      placeholder="Your message"
                      v-model="formData.message"
                      required
                      maxlength="500"
                    ></textarea>
                  </div>
                  <input type="submit" value="Send a Message" :disabled="isSubmitting" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Accordion from "../Accordion.vue";
export default {
  name: "FAQ2",
  components: { Accordion },
  data() {
    return {
      formData: {
        name: '',
        email: '',
        contact: '',
        subject: '',
        message: '',
      },
      formMessage: null,
      isSubmitting: false,
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.formData.name || !this.formData.email || !this.formData.contact || !this.formData.message) {
        this.formMessage = { type: 'error', text: 'All required fields must be filled!' };
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.formData.email)) {
        this.formMessage = { type: 'error', text: 'Please provide a valid email!' };
        return;
      }

      this.isSubmitting = true;
      this.formMessage = null;

      try {
        let formData = new FormData();
        formData.append("Name", this.formData.name);
        formData.append("Email", this.formData.email);
        formData.append("Phone", this.formData.contact);
        // Combine subject and message for Contact field
        const contactMessage = this.formData.subject 
          ? `${this.formData.subject}: ${this.formData.message}` 
          : this.formData.message;
        formData.append("Contact", contactMessage);

        const response = await fetch(
          "https://script.google.com/macros/s/AKfycbwC1pfWpoIi9_gRINZA1UEhKMaas9JhlNo5L1q3DVO0ktELh5l-XcFNsQiKLHSjY5nd/exec",
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.status === 200) {
          this.formMessage = { type: 'success', text: 'Message sent successfully!' };
          this.formData = {
            name: '',
            email: '',
            contact: '',
            subject: '',
            message: '',
          };
        } else {
          this.formMessage = { type: 'error', text: 'Failed to send message. Please try again.' };
        }
      } catch (error) {
        this.formMessage = { type: 'error', text: error?.message || 'An error occurred. Please try again.' };
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
